import { Component, ElementRef, HostListener, Input, ViewChild } from "@angular/core";
import { PonderDataClient } from "@apiserver-rest/ponder-data-client";
import { DataResponse } from "@apiserver-rest/ponder-data-client-base";
import { EventBroker } from "@ponder-core/events/eventBroker";
import { BusySpinComponent } from "@ponder-shared/components/busy-spin.component";
import { SvgIcon, SvgIconMap } from "@ponder-shared/utils/svgIcons";
import { take } from "rxjs";

@Component({
    selector: "deck-delete",
    imports: [BusySpinComponent],
    templateUrl: "./deck-delete.component.html"
})
export class DeckDeleteComponent {
    @Input({ required: true }) public deckId!: string;
    @Input({ required: true }) public deckName!: string;
    
    @ViewChild("confirmationModal") private confirmationModalRef!: ElementRef<HTMLElement>;

    public readonly deleteSvgIcon: string = SvgIconMap.get(SvgIcon.Delete)!;
    public readonly closeSvgIcon: string = SvgIconMap.get(SvgIcon.Close)!;

    public displayModal: boolean = false;
    public isRunning: boolean = false;
    public deletionFailed: boolean = false;

    constructor(private ponderDataClient: PonderDataClient, private events: EventBroker) {

    }

    // -------------------------------------------------------------------------------------
    // Global Events
    // -------------------------------------------------------------------------------------

    private mouseDownOutside: boolean = false;

    @HostListener("document:keydown.escape", ["$event"]) 
    private onEscapePressed(event: KeyboardEvent): void {
        this.onClose();
    }

    @HostListener("document:mousedown", ["$event"])
    private onGlobalMouseDown(event: MouseEvent): void {
        if (this.displayModal && !this.confirmationModalRef.nativeElement.contains(event.target as HTMLInputElement)) {
            this.mouseDownOutside = true;
        }
    }

    @HostListener("document:mouseup", ["$event"])
    private onGlobalMouseUp(event: MouseEvent): void {
        // Did the user click outside of our modal panel?
        if (this.displayModal && this.mouseDownOutside && !this.confirmationModalRef.nativeElement.contains((event.target as HTMLInputElement))) {
            this.onClose();
        }

        this.mouseDownOutside = false;
    }

    // -------------------------------------------------------------------------------------
    // Actions
    // -------------------------------------------------------------------------------------

    public onOpenClicked(): void {
        this.displayModal = true;
        this.deletionFailed = false;
    }

    public onClose(): void {
        this.displayModal = false;
    }

    public onConfirmClicked(): void {
        this.isRunning = true;

        this.ponderDataClient
            .deckDelete(this.deckId)
            .pipe(take(1))
            .subscribe({
                next: (response: DataResponse) => {
                    if (response.success) {
                        this.onClose();
                        this.events.deck.deckDeletedEvent.emit(this.deckId);
                    } else {
                        this.deletionFailed = true;
                    }
                },
                error: () => {
                    this.deletionFailed = true;
                }
            })
            .add(() => { this.isRunning = false; } );
    }
}